import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=07c83f20&scoped=true&"
import script from "./SideBar.vue?vue&type=script&lang=js&"
export * from "./SideBar.vue?vue&type=script&lang=js&"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=07c83f20&prod&scoped=true&lang=scss&"
import style1 from "./SideBar.vue?vue&type=style&index=1&id=07c83f20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c83f20",
  null
  
)

export default component.exports